import { AlertService } from '../../../../services/alert.service';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder, FormArray, AbstractControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Fondo } from '../../../../models/Fondo';
import { InversionistaFondo } from '../../../../models/InversionistaFondo';
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../../models/messages';
import { SectorEconomico } from '../../../../models/SectorEconomico';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { RiesgoService } from '../../../../services/riesgo/riesgo.service';
import { Router } from '@angular/router';
import { LoginService } from 'app/services/login/login.service';
import { LineaFondo } from 'app/models/LineaFondo';
import { SectorFondo } from 'app/models/SectorFondo';
import { ACCION_FONDO, SectorFondoTemp } from '../../../../models/UtilGestionFondo';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY"
  }
};

@Component({
  selector: 'app-nuevo-fondo',
  templateUrl: './nuevo-fondo.component.html',
  styleUrls: ['./nuevo-fondo.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class NuevoFondoComponent implements OnInit, OnDestroy {
  Label_id_soles=environment.ID_GUIA_SOLES;
  Label_id_dolares=environment.ID_GUIA_DOLARES;
  @ViewChild('rucInv', { static: true }) inputRuc: ElementRef;
  verMotivo:boolean = false;
  motivo:boolean = false;
  fondo: Fondo;
  flagVer: boolean = null;
  flagCrear: boolean = null;
  flagEditar: boolean = null;
  readonly CANAL_AUDITORIA: string = 'W';
  loadingInversionistas: boolean = false;
  loadingLineas: boolean = false;
  loadingLineasError: boolean = false;
  loadingInversionistasError: boolean = false;
  tituloFormFondo: string = '';
  userActive: any;
  idInv = '';
  idSector = '';
  IP: string = '';
  fechaActual: string;
  sectoresFondo: SectorEconomico[] = [];
  sectorGeneral: SectorEconomico = new SectorEconomico();
  caracteristicasSectoresFondo: any[] = [];
  sectorFondoTemp: SectorFondoTemp;
  sectorFondo: SectorFondo;
  sectoresFondoTemp: any[] = [];
  sectoresFondoArr: SectorFondo[] = [];
  lineasFondoTemp: any[] = [];
  empresasInversionistas: InversionistaFondo[] = [];
  lineasFondo: LineaFondo[] = [];
  minDate: Date = new Date();
  maxDate: Date = new Date();
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  ruc = new FormControl('');
  nombreSector = new FormControl('');
  tipoTasaDsc: string = 'Seleccione un tipo de tasa para continuar';
  reglasArrayTemp: any[] = [];
  diasSemana: any[] = [];
  meses: any[] = [];
  tiposReglas: any[] = [];
  categoriasRegla: any[] = [];
  criteriosComparacionRegla: any[] = [];
  tablasRegla: any[] = [];
  tiposLinea: any[] = [];
  tiposFrecuenciaPago: any[] = [];
  tiposMoneda: any[] = [];
  tiposFondo: any[] = [];
  tiposTasa: any[] = [];
  sumPorcentajeValido: boolean = true;
  sumMontoValido: boolean = true;
  filteredInversionistas: Observable<any[]>;
  filteredSectores: Observable<any[]>;
  primerFormGroup: FormGroup;
  segundoFormGroup: FormGroup;
  sectores: FormArray;
  formFondo: FormGroup;
  formLineaFondo: FormGroup;
  textConfirmSwal: string;
  idLineaFondo: number;
  idSectorFondo: number;
  nuevoFondo: boolean;
  nuevaLinea: boolean;
  nuevaRegla: boolean;
  tipoTasaCheckbox: boolean;
  diaSemanaCheckbox: boolean;

  subLista: Subscription[] = [];
  subFondo: Subscription = new Subscription();
  subListaInversionistas: Subscription = new Subscription();
  subListaSectores: Subscription = new Subscription();
  subListaSectoresFondo: Subscription = new Subscription();
  subCrearFondos: Subscription = new Subscription();
  subEditarFondos: Subscription = new Subscription();
  subLineaFondo: Subscription = new Subscription();

  constructor(
    private datePipe: DatePipe,
    private formBuilder: FormBuilder,
    private riesgoService: RiesgoService,
    private router: Router,
    private loginService: LoginService,
    private alertService: AlertService
  ) {

    this.fondo = this.riesgoService.dataFondo;
    this.flagCrear = this.riesgoService.flagCrear;
    this.flagEditar = this.riesgoService.flagEditar;
    this.flagVer = this.riesgoService.flagVer;

    if (this.flagCrear == null || this.flagEditar == null || this.flagVer == null) {
      this.router.navigate(['/fondo/concentracion/fondos/listado']);
    }

    this.fechaActual = new Date().toISOString().split('T')[0];
    this.userActive = JSON.parse(sessionStorage.getItem('UserActive'));
    //this.IP = JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip ? JSON.parse(sessionStorage.getItem('PUBLIC-IP')).ip : '192.168.1.1';
    this.IP = '192.168.1.1';
    this.tiposMoneda = this.riesgoService.Monedas;
    this.tiposFondo = this.riesgoService.TiposFondo;
    this.tiposTasa = this.riesgoService.TiposTasa;
    this.tiposLinea = this.riesgoService.TiposLinea;
    this.tiposFrecuenciaPago = this.riesgoService.TiposFrecuenciaPago;
    this.diasSemana = this.riesgoService.DiasSemana;
    this.meses = this.riesgoService.Meses;
  }

  ngOnInit() {
    this.tiposMoneda.forEach(moneda => moneda.value = (moneda.key === '') ? 'Seleccione una moneda' : moneda.value);

    this.obtenerSectores();

    this.tipoTasaCheckbox = false;

    this.primerFormGroup = this.formBuilder.group({
      idFondo: '',
      Nombre_Fondo: ['', [Validators.required, Validators.maxLength(30)]],
      Codigo_Fondo: ['', [Validators.required, Validators.maxLength(45)]],
      idEmpresa: ['', [Validators.required]],
      RSocialEmpresaRelacionada: '',
      Moneda: ['', [Validators.required]],
      MonedaDsc: '',
      Multiples_Moneda: false,
      Tipo: ['', [Validators.required]],
      TipoFondoDsc: '',
      Fecha_Inicio: new Date(),
      Fecha_Fin: null, // OPCIONAL
      Tasa: [{ value: '', disabled: true }],
      TipoTasa: '', // OPCIONAL
      Tasa_Diaria: null, // OPCIONAL
      Tasa_Mensual: null, // OPCIONAL
      Tasa_Anual: null, // OPCIONAL
      Cash: [0.00, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.max(999999999.99)]],
      Estado: ['A', [Validators.required]],
      EstadoFondoDsc: 'ACTIVO'
    });

    this.segundoFormGroup = this.formBuilder.group({
      Monto_Fondo: [null, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]],
      Monto_Fondo_Disponible: [null, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]],
      Monto_Fondo_Ejecutado: [null, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.max(999999999.99)]],
      Monto_Fondo_Bloqueado: [null, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.max(999999999.99)]],
      Tipo: ['', [Validators.required]],
      TipoLineaFondoDsc: '',
      sectores_fondo: this.formBuilder.array([]),
      lineas_fondo: this.formBuilder.array([]),
      porcentajeTotValid: [this.sumPorcentajeValido, [Validators.pattern('true')]], // bug con "requiredTrue"
      montoTotValid: [this.sumMontoValido, [Validators.pattern('true')]], // bug con "requiredTrue",
      Fecha_Inicio: [new Date(), [Validators.required]],
      Fecha_Fin: null, // OPCIONAL
      TasaInteres: 0.00,
      Motivo:null,
      TasaPenalizacion: 0.00,
      FrecuenciaPago: ['', [Validators.required]],
      TipoFrecuenciaPagoDsc: '',
      Minuto: 0,
      Hora: 0,
      Dia_Mes: 1, // OPCIONAL
      Dia_Semana: 1, // OPCIONAL
      Dia_Semana_Checkbox: false, // OPCIONAL
      Mes: 1,
      //FechaInicioTrim: new Date(), // SE CONSIDERA PARA FASE FUTURA
      //FechaFinTrim: null // SE CONSIDERA PARA FASE FUTURA
    });

    this.segundoFormGroup.valueChanges.subscribe(
      data => {
        data.FechaInicioTrim = this.datePipe.transform(data.FechaInicioTrim, 'yyyy-MM-dd');
        data.FechaFinTrim = this.maxDate;
        data.FechaFinTrim = this.datePipe.transform(data.FechaFinTrim, 'yyyy-MM-dd');
      }
    );

    this.formFondo = new FormGroup({
      idFondo: new FormControl(null),
      idEmpresa: new FormControl(),
      Nombre_Fondo: new FormControl(),
      Codigo_Fondo: new FormControl(),
      Monto_Fondo: new FormControl(),
      Monto_Fondo_Disponible: new FormControl(),
      Monto_Fondo_Ejecutado: new FormControl(),
      Monto_Fondo_Bloqueado: new FormControl(),
      Tipo: new FormControl(),
      Fecha_Inicio: new FormControl(),
      Fecha_Fin: new FormControl(),
      Tasa_Diaria: new FormControl(),
      Tasa_Mensual: new FormControl(),
      Tasa_Anual: new FormControl(),
      Cash: new FormControl(),
      Moneda: new FormControl(),
      Multiples_Moneda: new FormControl(),
      Estado: new FormControl(),

      lineas_fondo: this.groupLineas,
      sectores_fondo: this.groupSector,
      FrecuenciaPago: new FormControl(),
      Minuto: new FormControl(),
      Hora: new FormControl(),
      Dia_Mes: new FormControl(),
      Dia_Semana: new FormControl(),
      Mes: new FormControl(),
      //Motivo: new FormControl(),

      AltaFecha: new FormControl(),
      AltaCanal: new FormControl(),
      Usuario: new FormControl(),
      ModificacionUsuario: new FormControl(),
      ModificacionFecha: new FormControl(),
      ModificacionCanal: new FormControl(),
      IP: new FormControl()
    });


    this.obtenerEmpresasInversionistas();

    if (this.flagCrear) {
      this.tituloFormFondo = 'Crear fondo';
      this.agregarSector(this.flagCrear);
      this.sectoresFondoTemp.push(this.groupSector.at(0).value);
    }

    if (this.flagEditar) {
      this.tituloFormFondo = 'Modificar datos del fondo N° '.concat(this.fondo.idFondo.toString());
      this.tipoTasaDsc = 'Tasa';
      this.obtenerData();
      this.obtenerLineaFondo();
      console.log('lineas',this.lineasFondoTemp);
    }

    if (this.flagVer) {
      this.tituloFormFondo = 'Detalle del Fondo N° '.concat(this.fondo.idFondo.toString());
      this.tipoTasaDsc = 'Tasa';
      this.obtenerData();
      this.obtenerLineaFondo();
      this.primerFormGroup.disable();
      this.segundoFormGroup.disable();
    }
  }

  ngOnDestroy() {
    this.subLista.forEach(sub => { sub.unsubscribe() });
  }

  /**
  * Función para obtener inversionistas disponibles para asignar al fondo (crear) o inversionistas por id empresa para recuperarlo (actualizar, ver).
  */
  obtenerEmpresasInversionistas() {
    this.loadingInversionistas = true;
    this.subListaInversionistas = this.riesgoService.obtenerInversionistasFondoRiesgo().subscribe(
      (resInversionistas: InversionistaFondo[]) => {
        this.empresasInversionistas = resInversionistas;
        this.loadingInversionistas = false;

        this.empresasInversionistas.forEach(element => {
          element.Tipo_Doc_Identificacion = element.empresa.Tipo_Doc_Identificacion.toString();
          element.Num_Doc_Identificacion = element.empresa.Num_Doc_Identificacion.toString();
          element.Razon_Social = element.empresa.Razon_Social;

          if ((this.flagEditar || this.flagVer) && (element.idEmpresa == this.fondo.idEmpresa)) {
            this.primerFormGroup.get('idEmpresa').setValue(element.idEmpresa);
            this.primerFormGroup.get('RSocialEmpresaRelacionada').setValue(element.Razon_Social);
          }
        });

        this.obtenerInversionistasCombo();
      },
      (err: HttpErrorResponse) => {
        this.loadingInversionistasError = true;
        this.empresasInversionistas = [];
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Listado inversionistas no obtenida. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subListaInversionistas);
  }

  /**
  * Función para obtener lineas de fondo (crear) o por id fondo (actualizar, ver).
  */
  obtenerLineaFondo() {
    this.loadingLineas = true;
    this.subLineaFondo = this.riesgoService.obtenerLineasFondo().subscribe(
      (resLineaFondo: LineaFondo[]) => {
        this.lineasFondo = resLineaFondo;
        this.lineasFondo.forEach(element => {
          if (element.idFondo == this.fondo.idFondo) {
            this.lineasFondoTemp.push(element);
            this.segundoFormGroup.get('Tipo').setValue(element.Tipo);
            if (element.Tipo == 'C') {
              this.segundoFormGroup.get('TipoLineaFondoDsc').setValue('CRÉDITO');
            } else if (element.Tipo == 'B') {
              this.segundoFormGroup.get('TipoLineaFondoDsc').setValue('BONO');
            }
          }
        });
        this.loadingLineas = false;
        if (this.flagEditar || this.flagVer) {
          this.asignarLineas(this.lineasFondoTemp);
          if (this.flagVer) this.groupLineas.disable();
        }

      },
      (err: HttpErrorResponse) => {
        this.loadingLineas = false;
        this.loadingLineasError = true;
        this.lineasFondo = [];
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Linea fondo no obtenida. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subLineaFondo);
  }

  /**
  * Función para obtener sectores económicos para asignar al fondo (crear) o por id fondo para recuperarlos (crear, actualizar, ver).
  */
  obtenerSectores() {
    this.subListaSectoresFondo = this.riesgoService.obtenerSectoresEconomicos().subscribe(
      (resSectores: any[]) => {
        this.sectoresFondo = resSectores;

        this.sectorGeneral = this.sectoresFondo.find(s => s.Nombre_Sector.includes('GENERAL'));

        if (this.flagVer || this.flagEditar) {
          this.fondo.sectores_fondo.forEach(element => {
            let sectorFound = this.fondo.sectores.find(s => s.idSector == element.idSector);
            this.sectorFondo = new SectorFondo();
            this.sectorFondo.idFondo = element.idFondo;
            this.sectorFondo.idSector = element.idSector;
            this.sectorFondo.Porcentaje = element.Porcentaje_Real.toString();
            this.sectorFondo.Monto_Sector_Fondo = element.Monto_Sector_Fondo;
            this.sectorFondo.Monto_Sector_Fondo_Disponible = element.Monto_Sector_Fondo_Disponible;
            this.sectorFondo.Monto_Sector_Fondo_Ejecutado = element.Monto_Sector_Fondo_Ejecutado;
            this.sectorFondo.Monto_Sector_Fondo_Bloqueado = element.Monto_Sector_Fondo_Bloqueado;
            this.sectorFondo.Nombre_Sector = sectorFound.Nombre_Sector;
            this.sectorFondo.Codigo_Sector = sectorFound.Codigo_Sector;
            this.sectorFondo.Estado = (element.Estado == 'A') ? 'ACTIVO' : 'INACTIVO';
            this.sectorFondo.nuevo = false;
            this.sectoresFondoTemp.push(this.sectorFondo);
          });

          this.asignarSectores(this.sectoresFondoTemp);
          if (this.flagVer) this.groupSector.disable();
        }
      },
      (err: HttpErrorResponse) => {
        this.sectoresFondo = [];
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Listado sectores no obtenida. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );

    this.subLista.push(this.subListaSectoresFondo);

    this.obtenerSectoresCombo();
  }

  /**
  * Función para obtener datos del fondo y asignarlos a los formularios correspondientes (actualizar, ver).
  */
  obtenerData() {
    let tipoTasa: string = '';
    if (Number(this.fondo.Tasa_Diaria) == null && Number(this.fondo.Tasa_Mensual) && Number(this.fondo.Tasa_Anual)) {
      this.tipoTasaCheckbox = false;
    } else if (Number(this.fondo.Tasa_Diaria) > 0) {
      this.tipoTasaCheckbox = true;
      tipoTasa = 'D';
    } else if (Number(this.fondo.Tasa_Mensual) > 0) {
      this.tipoTasaCheckbox = true;
      tipoTasa = 'M';
    } else if (Number(this.fondo.Tasa_Anual) > 0) {
      this.tipoTasaCheckbox = true;
      tipoTasa = 'A';
    }
    let tipoFondoDsc: string = '';
    if (this.fondo.Tipo == 'G') {
      tipoFondoDsc = 'Grupo Empresarial/Empresa';
    } else if (this.fondo.Tipo == 'I') {
      tipoFondoDsc = 'Inversionista';
    }
    let estadoDsc: string = '';
    if (this.fondo.Estado == 'A') {
      estadoDsc = 'Activo';
    } else {
      estadoDsc = 'Inactivo';
    }

    this.primerFormGroup.patchValue({
      IdFondo: this.fondo.idFondo,
      Nombre_Fondo: this.fondo.Nombre_Fondo,
      Codigo_Fondo: this.fondo.Codigo_Fondo,
      idEmpresa: this.fondo.idEmpresa,
      RSocialEmpresaRelacionada: this.fondo.Razon_Social,
      Moneda: this.fondo.Moneda.toString(),
      MonedaDsc: this.fondo.Moneda_Descripcion,
      Multiples_Moneda: (this.fondo.Multiples_Moneda == 'A') ? true : false,
      Tipo: this.fondo.Tipo,
      TipoFondoDsc: tipoFondoDsc,
      Fecha_Inicio: this.fondo.Fecha_Inicio ? this.fondo.Fecha_Inicio : null,
      Fecha_Fin: this.fondo.Fecha_Fin ? this.fondo.Fecha_Fin : null,
      TipoTasa: tipoTasa,
      Tasa_Diaria: this.fondo.Tasa_Diaria,
      Tasa_Mensual: this.fondo.Tasa_Mensual,
      Tasa_Anual: this.fondo.Tasa_Anual,
      Cash: this.fondo.Cash,
      Estado: this.fondo.Estado,
      EstadoFondoDsc: estadoDsc
    });

    this.segundoFormGroup.patchValue({
      Monto_Fondo: this.fondo.Monto_Fondo,
      Monto_Fondo_Disponible: this.fondo.Monto_Fondo_Disponible,
      Monto_Fondo_Ejecutado: this.fondo.Monto_Fondo_Ejecutado,
      Monto_Fondo_Bloqueado: this.fondo.Monto_Fondo_Bloqueado,
      porcentajeTotValid: this.sumPorcentajeValido,
      montoTotValid: this.sumMontoValido,

      FrecuenciaPago: this.fondo.Frecuencia_Pago,
      TipoFrecuenciaPagoDsc: this.fondo.Tipo_Frecuencia_Pago_Dsc,
      Minuto: this.fondo.Minuto,
      Hora: this.fondo.Hora,
      Dia_Mes: this.fondo.Dia_Mes,
      Dia_Semana: this.fondo.Dia_Semana,
      Dia_Semana_Checkbox: (this.fondo.Dia_Semana != null || this.fondo.Dia_Semana != "") ? true : false,
      Mes: this.fondo.Mes,
    });
  }

  /**
  * Función para obtener el inversionista según vaya cambiando el valor del input de busqueda.
  */
  obtenerInversionistasCombo() {
    this.filteredInversionistas = this.ruc.valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterInv(state) : this.empresasInversionistas.slice())
    );
  }

  /**
  * Función para filtrar el inversionista por razon social, ver "obtenerInversionistasCombo()".
  */
  private _filterInv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.empresasInversionistas.filter(state => state.Razon_Social.toLowerCase().includes(filterValue) === true);
  }

  /**
  * Función para obtener el ruc del inversionista a partir de la razon social.
  */
  obtenerRucRazSocialInv(termino: string = '') {
    if (termino != null && termino != '') {
      let terminoLowerC = termino.toLowerCase();
      for (let p of this.empresasInversionistas) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(terminoLowerC) >= 0) {
          this.idInv = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  /**
  * Función completar el input del id empresa y razón social en el formulario.
  */
  obtenerRucInv(termino: any) {
    this.idInv = termino.NroDocumento;
    this.primerFormGroup.get('idEmpresa').setValue(termino.idEmpresa);
    this.primerFormGroup.get('RSocialEmpresaRelacionada').setValue(termino.Razon_Social);
    this.ruc.setValue('');
  }

  /**
  * Función para obtener el sector según vaya cambiando el valor del input de busqueda.
  */
  obtenerSectoresCombo() {
    this.filteredSectores = this.nombreSector.valueChanges.pipe(
      startWith(""),
      map(state => state ? this._filterSector(state) : this.sectoresFondo.slice())
    );
  }

  /**
  * Función para filtrar el sector por el nombre, ver "obtenerSectoresCombo()".
  */
  private _filterSector(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.sectoresFondo.filter(state => state.Nombre_Sector.toLowerCase().includes(filterValue) === true);
  }

  /**
  * Función para obtener el id del sector a partir del nombre.
  */
  obtenerSectorLista(termino: string = '') {
    if (termino != null && termino != '') {
      let terminoLowerC = termino.toLowerCase();
      for (let p of this.sectoresFondo) {
        let raz = p.Nombre_Sector.toLocaleLowerCase();
        if (raz.indexOf(terminoLowerC) >= 0) {
          this.idSector = p.Nombre_Sector;
        }
      }
    }
  }

  /**
  * Función para obtener los sectores del fondo del formulario.
  */
  get groupSector() {
    return this.segundoFormGroup.get('sectores_fondo') as FormArray;
  }

  /**
  * Función para obtener las lineas secundarias del fondo del formulario.
  */
  get groupLineas() {
    return this.segundoFormGroup.get('lineas_fondo') as FormArray;
  }

  /**
  * Función para crear un sector de tipo FromGroup, en caso sea un nuevo fondo, se asigna un sector "GENERAL" por defecto.
  */
  crearSector(crear?: boolean, nuevoSector?: boolean) {
    let montoFondo: number = this.segundoFormGroup.get('Monto_Fondo').value;
    let porcentajeInicial: number = 100;
    this.sumPorcentajeValido = false;
    this.sumMontoValido = false;

    return this.formBuilder.group({
      idSector: crear ? this.sectorGeneral.idSector : null,
      Nombre_Sector: crear ? this.sectorGeneral.Nombre_Sector : null,
      Porcentaje: [{ value: porcentajeInicial, disabled: this.flagVer }, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0), Validators.max(100)]],
      Monto_Sector_Fondo: [{ value: montoFondo, disabled: this.flagVer }, [Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0), Validators.max(999999999.99)]],
      Monto_Sector_Fondo_Disponible: [{ value: null, disabled: this.flagVer }],
      Monto_Sector_Fondo_Ejecutado: [{ value: null, disabled: this.flagVer }],
      Monto_Sector_Fondo_Bloqueado: [{ value: null, disabled: this.flagVer }],
      Estado: [{ value: null, disabled: this.flagVer }],
      nuevo: nuevoSector
    });
  }

  /**
  * Función para crear una linea de fondo de tipo FromGroup.
  */
  crearLinea() {
    console.log('entro a crear linea')
    return this.formBuilder.group({
      idFondo: this.flagCrear ? '' : this.fondo.idFondo,
      idLineaFondo: '',
      Monto_Linea: 0,
      Tipo: 'C',
      FechaInicio: new Date(),
      FechaFin: null,
      TasaInteres: 0.00,
      TasaPenalizacion: 0.00,
      FrecuenciaPago: 'D',
      Minuto: 0,
      Hora: 0,
      Dia_Mes: null,
      Dia_Semana: "",
      Dia_Semana_Checkbox: false,
      Mes: 1,
      Estado: [{ value: 'ACTIVO', disabled: true }],
      Motivo: null,
      nuevo: true
    });
  }

  /**
  * Función para agregar un sector creado al grupo de sectores existentes.
  */
  agregarSector(crear?: boolean, nuevoSector?: boolean) {
    this.groupSector.push(this.crearSector(crear, nuevoSector));
  }

  /**
  * Función para agregar una linea creada al grupo de lineas existentes.
  */
  agregarLinea() {
    console.log('agregar linea')
    this.groupLineas.push(this.crearLinea());
  }

  /**
  * Función para actualizar un sector según el índice y el nro. de sectores que tiene el fondo.
  */
  actualizarSector(index: number, sector: any) {
    sector.Monto_Sector_Fondo = (this.segundoFormGroup.get('Monto_Fondo').value * sector.Porcentaje) / 100;

    if (Number.isNaN(sector.Monto_Sector_Fondo)) {
      sector.Monto_Sector_Fondo = this.segundoFormGroup.get('Monto_Fondo').value;
      sector.Porcentaje = 100;
    }

    this.groupSector.at(index).patchValue({
      idSector: sector.idSector,
      Nombre_Sector: sector.Nombre_Sector,
      Porcentaje: (this.flagVer || this.flagEditar) ? sector.Porcentaje : 0,
      Monto_Sector_Fondo: (this.flagVer || this.flagEditar) ? sector.Monto_Sector_Fondo : 0,
      Monto_Sector_Fondo_Disponible: (this.flagVer || this.flagEditar) ? Number(sector.Monto_Sector_Fondo_Disponible) : 0,
      Monto_Sector_Fondo_Ejecutado: (this.flagVer || this.flagEditar) ? Number(sector.Monto_Sector_Fondo_Ejecutado) : 0,
      Monto_Sector_Fondo_Bloqueado: (this.flagVer || this.flagEditar) ? Number(sector.Monto_Sector_Fondo_Bloqueado) : 0,
      Estado: sector.Estado.toUpperCase()
    });

    if (this.groupSector.at(index).get('Estado').value == 'INACTIVO') this.groupSector.at(index).disable();
  }

  /**
  * Función para actualizar una linea según el índice y el nro. de lineas que tiene el fondo.
  */
  actualizarLinea(index: number, linea: any) {
    console.log('index',linea)
    this.groupLineas.at(index).patchValue({
      idFondo: linea.idFondo,
      idLineaFondo: linea.idLineaFondo,
      Monto_Linea: linea.Monto_Linea,
      Tipo: linea.Tipo,
      FechaInicio: linea.FechaInicio,
      FechaFin: linea.FechaFin,
      TasaInteres: +linea.TasaInteres,
      TasaPenalizacion: +linea.TasaPenalizacion,
      FrecuenciaPago: linea.FrecuenciaPago,
      Minuto: linea.Minuto,
      Hora: linea.Hora,
      Dia_Mes: +linea.Dia_Mes,
      Dia_Semana: (linea.Dia_Semana != null || linea.Dia_Semana != "") ? +linea.Dia_Semana : "",
      Dia_Semana_Checkbox: (linea.Dia_Semana == null || linea.Dia_Semana == "") ? false : true,
      Mes: +linea.Mes,
      Estado: this.flagCrear ? 'A' : linea.Estado_Descripcion.toUpperCase(),
      Usuario: linea.Usuario,
      nuevo: linea.idLineaFondo ? false : true,
      Motivo:linea.Motivo
    });
     if(this.groupLineas.at(index).get('Motivo').value != ""){
        this.verMotivo = true;
     };
    if (this.flagEditar && !this.groupLineas.at(index).get('nuevo').value) {
      //this.groupLineas.at(index).get('Monto_Linea').disable();
      this.groupLineas.at(index).get('Tipo').disable();
      
    }

    if (this.groupLineas.at(index).get('Estado').value == 'INACTIVO') this.groupLineas.at(index).disable();
  }

  /**
  * Función para quitar del listado un sector según el índice.
  */
  quitarSector(index: any) {
    this.groupSector.removeAt(index);
    this.sectoresFondoTemp.splice(index, 1);
  }

  /**
  * Función para quitar del listado una linea según el índice.
  */
  quitarLinea(index: any) {
    this.groupLineas.removeAt(index);
    this.lineasFondoTemp.splice(index, 1);
  }

  /**
  * Función para asignar uno o más sectores al grupo de sectores.
  */
  asignarSectores(sectoresArr: any) {
    sectoresArr.forEach((sectorElement: any, index: number) => {
      this.groupSector.push(this.crearSector(null, false));
      this.actualizarSector(index, sectorElement);
    });
  }

  /**
  * Función para asignar uno o más lineas al grupo de lineas de fondo.
  */
  asignarLineas(lineasArr: any) {
    lineasArr.forEach((lineaElement: any, index: number) => {
      this.groupLineas.push(this.crearLinea());
      this.actualizarLinea(index, lineaElement);
    });
  }

  /**
  * Función para completar la moneda en el formulario según la selección.
  */
  asignarMoneda(event) {
    this.primerFormGroup.get('Moneda').setValue(event.value);
    let moneda = this.primerFormGroup.get('Moneda').value;
    if (moneda == this.Label_id_soles) {
      this.primerFormGroup.get('MonedaDsc').setValue('SOLES');
    } else if (moneda == this.Label_id_dolares) {
      this.primerFormGroup.get('MonedaDsc').setValue('DOLARES');
    }
  }

  /**
  * Función para completar el tipo de fondo en el formulario según la selección.
  */
  asignarTipoFondo(event) {
    this.primerFormGroup.get('Tipo').setValue(event.value);
    let tipoFondo = this.primerFormGroup.get('Tipo').value;
    if (tipoFondo == 'G') {
      this.primerFormGroup.get('TipoFondoDsc').setValue('Grupo empresarial/empresa');
    } else if (tipoFondo == 'I') {
      this.primerFormGroup.get('TipoFondoDsc').setValue('Inversionista');
    }
  }

  /**
  * Función para habilitar o deshabilitar campos de Tipo de Tasa.
  */
  habilitarTipoTasa(event: any) {
    this.tipoTasaCheckbox = !this.tipoTasaCheckbox;
    if (!event.checked) {
      this.primerFormGroup.get('Tasa_Diaria').setValue(null);
      this.primerFormGroup.get('Tasa_Mensual').setValue(null);
      this.primerFormGroup.get('Tasa_Anual').setValue(null);
      this.primerFormGroup.get('TipoTasa').setValue('');
      this.tipoTasaDsc = 'Seleccione un tipo de tasa para continuar';
    }
  }

  /**
  * Función para asignar o no el día de la semana en la frecuencia de pago de tipo "SEMANAL".
  */
  habilitarDiaSemana(value: any, index?: number) {
    this.diaSemanaCheckbox = !this.diaSemanaCheckbox;
    let form: AbstractControl = (index) ? this.groupLineas.at(index).get('Dia_Semana') : this.segundoFormGroup.get('Dia_Semana');
    if (!value.checked) {
      form.setValue("");
    } else {
      form.setValue(0);
    }
  }

  /**
  * Función para completar la tasa en el formulario según la selección.
  */
  asignarTasa(event) {
    this.primerFormGroup.get('Tasa_Diaria').setValue(null);
    this.primerFormGroup.get('Tasa_Diaria').clearValidators();
    this.primerFormGroup.get('Tasa_Mensual').setValue(null);
    this.primerFormGroup.get('Tasa_Mensual').clearValidators();
    this.primerFormGroup.get('Tasa_Anual').setValue(null);
    this.primerFormGroup.get('Tasa_Anual').clearValidators();

    this.primerFormGroup.get('TipoTasa').setValue(event.value);
    let tipoTasa = this.primerFormGroup.get('TipoTasa').value;

    if (tipoTasa == 'D') {
      this.tipoTasaDsc = 'Monto Tasa Diaria';
      this.primerFormGroup.get('Tasa_Diaria').setValidators([Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]);
      this.primerFormGroup.get('Tasa_Mensual').setValue(0);
      this.primerFormGroup.get('Tasa_Anual').setValue(0);
    } else if (tipoTasa == 'M') {
      this.tipoTasaDsc = 'Monto Tasa Mensual';
      this.primerFormGroup.get('Tasa_Diaria').setValue(0);
      this.primerFormGroup.get('Tasa_Mensual').setValidators([Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]);
      this.primerFormGroup.get('Tasa_Anual').setValue(0);
    } else if (tipoTasa == 'A') {
      this.tipoTasaDsc = 'Monto Tasa Anual';
      this.primerFormGroup.get('Tasa_Diaria').setValue(0);
      this.primerFormGroup.get('Tasa_Mensual').setValue(0);
      this.primerFormGroup.get('Tasa_Anual').setValidators([Validators.required, Validators.pattern(/^\d*\.?\d{0,2}$/), Validators.min(0.01), Validators.max(999999999.99)]);
    }
  }

  /**
  * Función para completar el tipo de linea de fondo en el formulario (o grupo mediante el índice) según la selección.
  */
  asignarTipoLineaFondo(event, index?: number) {
    let form: any;
    let formPrincipal: any;
    if (index) {
      form = this.groupLineas.at(index);
      formPrincipal = form.get('Tipo');
    } else {
      form = this.segundoFormGroup;
      formPrincipal = form.get('Tipo');
    }
    formPrincipal.setValue(event.value);
    let tipoLineaFondo = formPrincipal.value;
    if (tipoLineaFondo == 'C' && !index) {
      form.get('TipoLineaFondoDsc').setValue('Crédito');
    } else if (tipoLineaFondo == 'B' && !index) {
      form.get('TipoLineaFondoDsc').setValue('Bono');
    }
  }

  /**
  * Función para completar el monto disponible en el formulario según el valor del monto total.
  */
  actualizarMonto() {
    this.segundoFormGroup.patchValue({
      Monto_Fondo_Disponible: this.segundoFormGroup.get('Monto_Fondo').value,
      Monto_Fondo_Ejecutado: 0,
      Monto_Fondo_Bloqueado: 0
    });
  }

  /**
  * Función para agregar o quitar los sectores en el grupo de sectores actual.
  */
  editarSectorEnLista(termino: any, tipoOperacion: string, index: number) {
    let sector = this.sectoresFondoTemp.find(s => s.idSector == termino.idSector);
    if (tipoOperacion == 'A') {
      if (sector != undefined) {
        this.sectoresFondoTemp.splice(index, 1);
        Swal.fire({
          title: 'Atención',
          text: 'El sector ya ha sido seleccionado. Elije otro.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
      } else {
        this.sectoresFondoTemp.push(termino);
        this.actualizarSector(index, termino);
      }
    } else if (tipoOperacion == 'D') {
      this.sectoresFondoTemp.splice(index, 1);
      this.quitarSector(index);
    }
  }

  /**
  * Validación de formulario de lineas de fondo (suplir un bug de validación del formulario).
  */
  isSegundoFormValid(): boolean {
    return this.segundoFormGroup.get('Monto_Fondo').valid &&
      this.segundoFormGroup.get('Monto_Fondo_Disponible').valid &&
      this.segundoFormGroup.get('Monto_Fondo_Ejecutado').valid &&
      this.segundoFormGroup.get('Monto_Fondo_Bloqueado').valid &&
      this.segundoFormGroup.get('Tipo').valid &&
      this.segundoFormGroup.get('TipoLineaFondoDsc').valid &&
      this.segundoFormGroup.get('sectores_fondo').valid &&
      this.segundoFormGroup.get('porcentajeTotValid').valid &&
      this.segundoFormGroup.get('montoTotValid').valid;
  }

  /**
  * Función para validar el total de porcentajes de los distintos sectores presentes en el grupo de sectores, ver "calcularTotalPorcentajeSectores()"".
  */
  isTotPorcentajeValido(porcentaje: number, index: number) {
    this.groupSector.at(index).patchValue({
      Porcentaje: porcentaje,
      Monto_Sector_Fondo: (this.segundoFormGroup.get('Monto_Fondo').value * porcentaje) / 100,
      Monto_Sector_Fondo_Disponible: (this.segundoFormGroup.get('Monto_Fondo').value * porcentaje) / 100,
      Monto_Sector_Fondo_Ejecutado: 0,
      Monto_Sector_Fondo_Bloqueado: 0
    });

    if (this.calcularTotalPorcentajeSectores() > 100) {
      this.sumPorcentajeValido = false;
    } else {
      this.sumPorcentajeValido = true;
    }
  }

  /**
  * Función para validar el total de montos de los distintos sectores presentes en el grupo de sectores, ver "calcularTotalMontoSectores()".
  */
  isTotMontoValido(monto: number, index: number) {
    this.groupSector.at(index).patchValue({
      Porcentaje: (monto * 100) / this.segundoFormGroup.get('Monto_Fondo').value,
      Monto_Sector_Fondo: monto,
      Monto_Sector_Fondo_Disponible: monto,
      Monto_Sector_Fondo_Ejecutado: 0,
      Monto_Sector_Fondo_Bloqueado: 0
    });

    if (this.calcularTotalMontoSectores() > this.segundoFormGroup.get('Monto_Fondo').value) {
      this.sumMontoValido = false;
    } else {
      this.sumMontoValido = true;
    }
  }

  /**
  * Función para calcular el total de porcentajes de los sectores presentes en el grupo de sectores.
  */
  calcularTotalPorcentajeSectores(): number {
    let sectores = this.groupSector;
    return sectores.value
      .map((sector: SectorFondoTemp) => ((sector.Monto_Sector_Fondo * 100) / this.segundoFormGroup.get('Monto_Fondo').value))
      .reduce((accum: number, currentValue: number) => accum + currentValue);
  }

  /**
  * Función para calcular el total de montos de los sectores presentes en el grupo de sectores.
  */
  calcularTotalMontoSectores(): number {
    let sectores = this.groupSector;
    return sectores.value
      .map((sector: SectorFondoTemp) => ((this.segundoFormGroup.get('Monto_Fondo').value * sector.Porcentaje) / 100))
      .reduce((accum: number, currentValue: number) => accum + currentValue);
  }

  /**
  * Función para completar la frecuencia de pago del fondo en el formulario (o grupo mediante el índice) según la selección.
  */
  asignarTipoFrecuenciaPago(event, index?: number) {
    let form: any;
    let formPrincipal: any;
    if (index) {
      formPrincipal = this.groupLineas.at(index);
      form = this.groupLineas.at(index).get('FrecuenciaPago');
    } else {
      formPrincipal = this.segundoFormGroup;
      form = this.segundoFormGroup.get('FrecuenciaPago');
    }

    form.setValue(event.value);
    let tipoFrecuenciaPago = form.value;
    if (tipoFrecuenciaPago == 'D') {
      formPrincipal.patchValue({
        Hora: 0,
        Minuto: 0
      });
      formPrincipal.get('Hora').setValidators([Validators.required, Validators.min(0), Validators.max(23)]);
      formPrincipal.get('Minuto').setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      formPrincipal.get('Dia_Semana').clearValidators();
      formPrincipal.get('Dia_Semana').setValue("");
      formPrincipal.get('Dia_Mes').clearValidators();
      formPrincipal.get('Dia_Mes').setValue(null);
      formPrincipal.get('Mes').clearValidators();
      formPrincipal.get('Mes').setValue(null);
    } else if (tipoFrecuenciaPago == 'S') {
      formPrincipal.patchValue({
        Hora: 0,
        Minuto: 0,
        Dia_Semana: null
      });
      formPrincipal.get('Hora').setValidators([Validators.required, Validators.min(0), Validators.max(23)]);
      formPrincipal.get('Minuto').setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      formPrincipal.get('Dia_Mes').clearValidators();
      formPrincipal.get('Dia_Mes').setValue(null);
      formPrincipal.get('Mes').clearValidators();
      formPrincipal.get('Mes').setValue(null);
    } else if (tipoFrecuenciaPago == 'M' || tipoFrecuenciaPago == 'A') {
      formPrincipal.patchValue({
        Hora: 0,
        Minuto: 0,
        Mes: null,
        Dia_Mes: 1
      });
      formPrincipal.get('Hora').setValidators([Validators.required, Validators.min(0), Validators.max(23)]);
      formPrincipal.get('Minuto').setValidators([Validators.required, Validators.min(0), Validators.max(59)]);
      formPrincipal.get('Mes').setValidators([Validators.min(1), Validators.max(12)]);
      formPrincipal.get('Dia_Semana').clearValidators();
      formPrincipal.get('Dia_Semana').setValue("");
    } else if (tipoFrecuenciaPago == 'T') {
      formPrincipal.patchValue({
        Hora: 0,
        Minuto: 0,
        FechaInicioTrim: new Date(),
        FechaFinTrim: new Date()
      });
      formPrincipal.get('Dia_Semana').clearValidators();
      formPrincipal.get('Dia_Semana').setValue("");
      formPrincipal.get('Dia_Mes').clearValidators();
      formPrincipal.get('Dia_Mes').setValue(null);
      formPrincipal.get('Mes').clearValidators();
      formPrincipal.get('Mes').setValue(null);
    } else if (tipoFrecuenciaPago == 'O') {
      formPrincipal.get('Hora').clearValidators();
      formPrincipal.get('Hora').setValue(null);
      formPrincipal.get('Minuto').clearValidators();
      formPrincipal.get('Minuto').setValue(null);
      formPrincipal.get('Dia_Semana').clearValidators();
      formPrincipal.get('Dia_Semana').setValue("");
      formPrincipal.get('Dia_Mes').clearValidators();
      formPrincipal.get('Dia_Mes').setValue(null);
      formPrincipal.get('Mes').clearValidators();
      formPrincipal.get('Mes').setValue(null);
    }
  }

  /**
* Función para preparar el body de creación o actualización del fondo.
* @param accion Tipo de acción a realizar (ver enum ACCION_FONDO)
* @param indexLinea Índice del elemento en el FormArray lineas_fondo
* @param indexSector Índice del elemento en el FormArray sectores_fondo
*/
  armarBodyFondo(accion: number, indexLinea?: number, indexSector?: number) {
    let moneda = Number(this.primerFormGroup.get('Moneda').value);

    if (accion == ACCION_FONDO.REGISTRO_FONDO) {
      this.armarRegistro(moneda);
    } else if (accion == ACCION_FONDO.MODIFICAR_DATOS_GENERALES_FONDO) {
      this.armarModificacionDatosGenerales(moneda);
    } else if (accion == ACCION_FONDO.MODIFICAR_LINEA_FONDO) {
      this.armarModificacionLinea(indexLinea);
    } else if (accion == ACCION_FONDO.MODIFICAR_SECTOR_FONDO) {
      this.armarModificacionSector(indexSector);
    }
  }

  armarRegistro(moneda: number) {
    let fechaIFondoCreacion = this.primerFormGroup.get('Fecha_Inicio').value;
    let fechaILineaCreacion = this.segundoFormGroup.get('Fecha_Inicio').value;
    let fechaFFondoCreacion = this.primerFormGroup.get('Fecha_Fin').value;
    let fechaFLineaCreacion = this.segundoFormGroup.get('Fecha_Fin').value;

    let boolDiaSemana: boolean = this.segundoFormGroup.get('Dia_Semana_Checkbox').value;

    let bodyLineaPrincipal = this.formBuilder.group({
      idLineaFondo: null,
      idFondo: null,
      Monto_Linea: this.segundoFormGroup.get('Monto_Fondo').value,
      Tipo: this.segundoFormGroup.get('Tipo').value,
      FechaInicio: this.datePipe.transform(fechaILineaCreacion, 'yyyy-MM-dd'),
      FechaFin: this.datePipe.transform(fechaFLineaCreacion, 'yyyy-MM-dd'),
      TasaInteres: this.segundoFormGroup.get('TasaInteres').value,
      TasaPenalizacion: this.segundoFormGroup.get('TasaPenalizacion').value,
      FrecuenciaPago: this.segundoFormGroup.get('FrecuenciaPago').value,
      Minuto: this.segundoFormGroup.get('Minuto').value,
      Hora: this.segundoFormGroup.get('Hora').value,
      Dia_Mes: this.segundoFormGroup.get('Dia_Mes').value,
      Dia_Semana: (boolDiaSemana) ? +this.segundoFormGroup.get('Dia_Semana').value : "",
      Mes: this.segundoFormGroup.get('Mes').value,
      nuevo: true,
      Motivo:this.segundoFormGroup.get('Motivo').value,
    });

    if (this.groupLineas.length > 0) {
      this.groupLineas.clear();
      this.groupLineas.push(this.formBuilder.group(bodyLineaPrincipal.getRawValue()));
    } else {
      this.groupLineas.push(this.formBuilder.group(bodyLineaPrincipal.getRawValue()));
    }

    let boolMonedaMultiple: boolean = this.primerFormGroup.get('Multiples_Moneda').value;

    this.formFondo = this.formBuilder.group({
      idEmpresa: this.primerFormGroup.get('idEmpresa').value,
      Nombre_Fondo: this.primerFormGroup.get('Nombre_Fondo').value,
      Codigo_Fondo: this.primerFormGroup.get('Codigo_Fondo').value,
      Monto_Fondo: this.segundoFormGroup.get('Monto_Fondo').value,
      Monto_Fondo_Disponible: this.segundoFormGroup.get('Monto_Fondo').value,
      Monto_Fondo_Ejecutado: 0.00,
      Monto_Fondo_Bloqueado: 0.00,
      Tipo: this.primerFormGroup.get('Tipo').value,
      sectores_fondo: this.groupSector,
      reglas_fondo: [],
      financiamientos_fondo: [],
      lineas_fondo: this.groupLineas,
      Fecha_Inicio: this.datePipe.transform(fechaIFondoCreacion, 'yyyy-MM-dd'),
      Fecha_Fin: this.datePipe.transform(fechaFFondoCreacion, 'yyyy-MM-dd'),
      Tasa_Diaria: this.primerFormGroup.get('Tasa_Diaria').value,
      Tasa_Mensual: this.primerFormGroup.get('Tasa_Mensual').value,
      Tasa_Anual: this.primerFormGroup.get('Tasa_Anual').value,
      Cash: this.primerFormGroup.get('Cash').value,
      Moneda: moneda,
      Multiples_Moneda: (boolMonedaMultiple) ? 'A' : 'I',
      Estado: "A",
      AltaFecha: this.fechaActual,
      AltaCanal: this.CANAL_AUDITORIA,
      Usuario: this.userActive.Usuario,
      IP: this.IP
    });
  }

  armarModificacionDatosGenerales(moneda: number) {
    let boolMonedaMultiple: boolean = this.primerFormGroup.get('Multiples_Moneda').value;

    this.formFondo = this.formBuilder.group({
      idEmpresa: this.primerFormGroup.get('idEmpresa').value,
      Nombre_Fondo: this.primerFormGroup.get('Nombre_Fondo').value,
      Codigo_Fondo: this.primerFormGroup.get('Codigo_Fondo').value,
      Moneda: moneda,
      Multiples_Moneda: (boolMonedaMultiple) ? 'A' : 'I',
      Tipo: this.primerFormGroup.get('Tipo').value,
      Fecha_Inicio: this.datePipe.transform(this.primerFormGroup.get('Fecha_Inicio').value, 'yyyy-MM-dd'),
      Fecha_Fin: this.datePipe.transform(this.primerFormGroup.get('Fecha_Fin').value, 'yyyy-MM-dd'),
      Tasa_Diaria: this.primerFormGroup.get('Tasa_Diaria').value,
      Tasa_Mensual: this.primerFormGroup.get('Tasa_Mensual').value,
      Tasa_Anual: this.primerFormGroup.get('Tasa_Anual').value,
      Cash: this.primerFormGroup.get('Cash').value,
      Estado: this.primerFormGroup.get('Estado').value,
      Usuario: this.userActive.Usuario
    });
  }

  armarModificacionLinea(indexLinea: number) {
    console.log('entro a armarModificacionLinea',indexLinea)
    let boolDiaSemana: boolean = this.groupLineas.at(indexLinea).get('Dia_Semana_Checkbox').value;

    this.idLineaFondo = this.groupLineas.at(indexLinea).get('idLineaFondo').value;
    this.nuevaLinea = this.groupLineas.at(indexLinea).get('nuevo').value;
    let fechaInicioLinea = this.groupLineas.at(indexLinea).get('FechaInicio').value;
    let fechaFinLinea = this.groupLineas.at(indexLinea).get('FechaFin').value;
    fechaInicioLinea = this.datePipe.transform(fechaInicioLinea, 'yyyy-MM-dd');
    fechaFinLinea = this.datePipe.transform(fechaFinLinea, 'yyyy-MM-dd');

    if (this.nuevaLinea) {

      this.formFondo = this.formBuilder.group({
        Monto_Linea: this.groupLineas.at(indexLinea).get('Monto_Linea').value,
        Tipo: this.groupLineas.at(indexLinea).get('Tipo').value,
        idFondo: this.fondo.idFondo,
        Usuario: this.userActive.Usuario,
        FechaInicio: fechaInicioLinea,
        FechaFin: fechaFinLinea,
        FrecuenciaPago: this.groupLineas.at(indexLinea).get('FrecuenciaPago').value,
        TasaInteres: this.groupLineas.at(indexLinea).get('TasaInteres').value,
        TasaPenalizacion: this.groupLineas.at(indexLinea).get('TasaPenalizacion').value,
        //Motivo:this.groupLineas.at(indexLinea).get('Motivo').value,
        Minuto: +this.groupLineas.at(indexLinea).get('Minuto').value,
        Hora: +this.groupLineas.at(indexLinea).get('Hora').value,
        Dia_Mes: (+this.groupLineas.at(indexLinea).get('Dia_Mes').value) == 0 ? null : (+this.groupLineas.at(indexLinea).get('Dia_Mes').value),
        Dia_Semana: (boolDiaSemana) ? +this.groupLineas.at(indexLinea).get('Dia_Semana').value : "",
        Mes: (+this.groupLineas.at(indexLinea).get('Mes').value) == 0 ? null : (+this.groupLineas.at(indexLinea).get('Mes').value),
      });

    } else {

      let fechaInicioLinea2 = this.groupLineas.at(indexLinea).get('FechaInicio').value;
      let fechaFinLinea2 = this.groupLineas.at(indexLinea).get('FechaFin').value;
      fechaInicioLinea2 = this.datePipe.transform(fechaInicioLinea2, 'yyyy-MM-dd');
      fechaFinLinea2 = this.datePipe.transform(fechaFinLinea2, 'yyyy-MM-dd');
      this.formFondo = this.formBuilder.group({
        Monto_Linea: this.groupLineas.at(indexLinea).get('Monto_Linea').value,
        Tipo: this.groupLineas.at(indexLinea).get('Tipo').value,
        idFondo: this.fondo.idFondo,
        Usuario: this.userActive.Usuario,
        FechaInicio: fechaInicioLinea2,
        FechaFin: fechaFinLinea2,
        FrecuenciaPago: this.groupLineas.at(indexLinea).get('FrecuenciaPago').value,
        TasaInteres: this.groupLineas.at(indexLinea).get('TasaInteres').value,
        TasaPenalizacion: this.groupLineas.at(indexLinea).get('TasaPenalizacion').value,
        Motivo:this.groupLineas.at(indexLinea).get('Motivo').value,
        Minuto: +this.groupLineas.at(indexLinea).get('Minuto').value,
        Hora: +this.groupLineas.at(indexLinea).get('Hora').value,
        Dia_Mes: (+this.groupLineas.at(indexLinea).get('Dia_Mes').value) == 0 ? null : (+this.groupLineas.at(indexLinea).get('Dia_Mes').value),
        Dia_Semana: (boolDiaSemana) ? +this.groupLineas.at(indexLinea).get('Dia_Semana').value : "",
        Mes: (+this.groupLineas.at(indexLinea).get('Mes').value) == 0 ? null : (+this.groupLineas.at(indexLinea).get('Mes').value),
      });

    }
  }

  armarModificacionSector(indexSector: number) {
    this.nuevoFondo = this.groupSector.at(indexSector).get('nuevo').value;
    this.formFondo = this.formBuilder.group({
      idFondo: this.fondo.idFondo,
      idSector: this.groupSector.at(indexSector).get('idSector').value,
      Estado: "A",
      Porcentaje: this.groupSector.at(indexSector).get('Porcentaje').value,
      Monto_Sector_Fondo: this.groupSector.at(indexSector).get('Monto_Sector_Fondo').value,
      Monto_Sector_Fondo_Disponible: this.groupSector.at(indexSector).get('Monto_Sector_Fondo_Disponible').value,
      Monto_Sector_Fondo_Ejecutado: this.groupSector.at(indexSector).get('Monto_Sector_Fondo_Ejecutado').value,
      Monto_Sector_Fondo_Bloqueado: this.groupSector.at(indexSector).get('Monto_Sector_Fondo_Bloqueado').value,
      Usuario: this.userActive.Usuario
    });
  }

  /**
  * Función para registrar un fondo.
  */
  crearFondo() {
    this.armarBodyFondo(ACCION_FONDO.REGISTRO_FONDO);

    Swal.fire({
      text: 'Confirmar la creación del nuevo fondo',
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, crear fondo',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.riesgoService.registrarFondo(this.formFondo.getRawValue()).subscribe(
          (resFondo: any) => {
            let idFondo = resFondo.message.idFondo;
            Swal.fire({
              title: 'Éxito',
              text: '¡El fondo N° '.concat(idFondo, ' ha sido registrado correctamente!'),
              type: 'success',
              allowOutsideClick: false,
              heightAuto: false
            });

            this.loginService.clickGuard = true;
            this.router.navigate(['/fondo/concentracion/fondos/listado']);
          },
          (err: HttpErrorResponse) => {
            Swal.fire({
              title: 'Error',
              html: this.alertService.createTextError(err, 'Hubo un error a la hora de crear el fondo. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );

      }

    });

  }

  /**
  * Función para editar un aspecto/parte del fondo (datos generales, linea del fondo, reglas).
  */
  editarFondo(nroForm: number, indiceLinea?: number, indiceSector?: number) {
    this.armarBodyFondo(nroForm, indiceLinea, indiceSector);

    this.armarTextoSwal(nroForm);

    Swal.fire({
      text: this.textConfirmSwal,
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, guardar cambios',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        if (nroForm == ACCION_FONDO.MODIFICAR_DATOS_GENERALES_FONDO) {
          this.modificarDatosGeneralesFondo(nroForm);
        } else if (nroForm == ACCION_FONDO.MODIFICAR_LINEA_FONDO) {
          this.modificarLineaFondo();
        } else if (nroForm == ACCION_FONDO.MODIFICAR_SECTOR_FONDO) {
          this.modificarSectorFondo();
        }

      }
    });
  }

  armarTextoSwal(nroForm: number) {
    if (nroForm == ACCION_FONDO.MODIFICAR_DATOS_GENERALES_FONDO) {
      this.textConfirmSwal = 'Confirmar la actualización de los datos generales del fondo';
    } else if (nroForm == ACCION_FONDO.MODIFICAR_LINEA_FONDO && this.nuevaLinea) {
      this.textConfirmSwal = 'Confirmar el registro del la linea de fondo';
    } else if (nroForm == ACCION_FONDO.MODIFICAR_LINEA_FONDO && !this.nuevaLinea) {
      this.textConfirmSwal = 'Confirmar la actualizacion de la linea de fondo';
    } else if (nroForm == ACCION_FONDO.MODIFICAR_SECTOR_FONDO && this.nuevoFondo) {
      this.textConfirmSwal = 'Confirmar la creación del sector';
    } else if (nroForm == ACCION_FONDO.MODIFICAR_SECTOR_FONDO && !this.nuevoFondo) {
      this.textConfirmSwal = 'Confirmar la actualización del sector';
    }
  }

  modificarDatosGeneralesFondo(nroForm: number) {
    this.riesgoService.actualizarFondo(nroForm, this.formFondo.getRawValue(), this.fondo.idFondo).subscribe(
      (resFondo: any) => {
        let idFondo = resFondo.message.idFondo;
        Swal.fire({
          title: 'Éxito',
          text: '¡Los datos del fondo N° '.concat(idFondo, ' han sido actualizados correctamente!'),
          type: 'success',
          allowOutsideClick: false,
          heightAuto: false
        });

        this.loginService.clickGuard = true;
        this.router.navigate(['/fondo/concentracion/fondos/listado']);
      },
      (err: HttpErrorResponse) => {
        Swal.fire({
          title: 'Error',
          html: this.alertService.createTextError(err, 'Hubo un error a la hora de actualizar los datos generales del fondo. <br/>'),
          type: "error",
          allowOutsideClick: true,
          heightAuto: false
        });
      }
    );
  }

  modificarLineaFondo() {
    if (this.nuevaLinea) {
      if(this.formFondo.get('Monto_Linea') >= this.segundoFormGroup.get('Monto_Fondo_Disponible').value){
        Swal.fire({
          title: 'Precaución',
          text: 'El monto ingresado va superar o esta superando el monto disponible del fondo',
          type: 'warning',
          allowOutsideClick: false,
          heightAuto: false
        }).then((result) =>{
          if(result.value){
            this.riesgoService.crearLineafondo(this.formFondo.getRawValue()).subscribe(
              (data) => {
                console.log('data',data)
                Swal.fire({
                  title: 'Éxito',
                  text: '¡La linea del fondo N° '.concat(this.fondo.idFondo.toString(), ' ha sido registrada correctamente!'),
                  type: 'success',
                  allowOutsideClick: false,
                  heightAuto: false
                });
      
                this.loginService.clickGuard = true;
                this.router.navigate(['/fondo/concentracion/fondos/listado']);
              },
              (err: HttpErrorResponse) => {
                Swal.fire({
                  title: 'Error',
                  html: this.alertService.createTextError(err, 'Hubo un error a la hora de crear la linea de fondo. <br/>'),
                  type: "error",
                  allowOutsideClick: true,
                  heightAuto: false
                });
              }
            );
          }
        });
      }   
    } else {
      if(this.motivo){
        if(this.formFondo.get('Motivo').value == null || this.formFondo.get('Motivo').value.trim() === ""){
          Swal.fire({
            title: 'Error',
            text: 'El motivo no puede estar vacío',
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
          return;
        }
      }else{
        this.formFondo.get('Motivo').setValue('');
      } 
      this.ValidarMonto();
      

    }
  }


ValidarMonto(){
  if(this.formFondo.get('Monto_Linea') >= this.segundoFormGroup.get('Monto_Fondo_Disponible').value){
    Swal.fire({
      title: 'Precaución',
      text: 'El monto ingresado va superar o esta superando el monto disponible del fondo',
      type: 'warning',
      allowOutsideClick: false,
      heightAuto: false
    }).then((result) =>{
      if (result.value){
        this.riesgoService.actualizarLineaYFrecuenciaFondo(this.formFondo.getRawValue(), this.idLineaFondo).subscribe(
          (datas:any) => {
            this.warn(datas)
  
            
          },
          (err: HttpErrorResponse) => {
            Swal.fire({
              title: 'Error',
              html: this.alertService.createTextError(err, 'Hubo un error a la hora de actualizar la linea de fondo. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );
      }
    });
  }
}

 warn(data:any){
  if(data.message.warn != null){
    Swal.fire({
      title: 'Precaución',
      text: data.message.warn,
      type: 'warning',
      allowOutsideClick: false,
      heightAuto: false
    }).then((result)=>{
      if(result.value){
        Swal.fire({
          title: 'Éxito',
          text: '¡La linea de fondo ha sido actualizada correctamente!',
          type: 'success',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(['/fondo/concentracion/fondos/listado']);
      }
    });
  }else{
      Swal.fire({
        title: 'Éxito',
        text: '¡La linea de fondo ha sido actualizada correctamente!',
        type: 'success',
        allowOutsideClick: false,
        heightAuto: false
      });
  } 
 }

  modificarSectorFondo() {
    if (this.nuevoFondo) {

      this.riesgoService.crearSectorFondo(this.formFondo.getRawValue()).subscribe(
        () => {
          Swal.fire({
            title: 'Éxito',
            text: '¡El sector del fondo ha sido creado correctamente!',
            type: 'success',
            allowOutsideClick: false,
            heightAuto: false
          });

          this.loginService.clickGuard = true;
          this.router.navigate(['/fondo/concentracion/fondos/listado']);
        },
        (err: HttpErrorResponse) => {
          Swal.fire({
            title: 'Error',
            html: this.alertService.createTextError(err, 'Hubo un error a la hora de crear el sector del fondo. <br/>'),
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
        }
      );

    } else {

      this.riesgoService.actualizarSectorFondo(this.formFondo.getRawValue(), this.fondo.idFondo).subscribe(
        () => {
          Swal.fire({
            title: 'Éxito',
            text: '¡El sector del fondo ha sido actualizado correctamente!',
            type: 'success',
            allowOutsideClick: false,
            heightAuto: false
          });

          this.loginService.clickGuard = true;
          this.router.navigate(['/fondo/concentracion/fondos/listado']);
        },
        (err: HttpErrorResponse) => {
          Swal.fire({
            title: 'Error',
            html: this.alertService.createTextError(err, 'Hubo un error a la hora de actualizar el sector del fondo. <br/>'),
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
        }
      );

    }
  }

  /**
  * Función para dar de baja una linea del fondo (cambio de estado a INACTIVO).
  */
  cambiarEstadoLinea(index: number, estado: string) {
    let textSwal = '';

    if (estado == 'A') {
      textSwal = 'Confirmar la activación de la linea de fondo.';
    } else {
      textSwal = 'Confirmar la desactivación de la linea de fondo.';
    }

    Swal.fire({
      text: textSwal,
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, continuar',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.idLineaFondo = this.groupLineas.at(index).get('idLineaFondo').value;
        let fechaInicioLinea = this.groupLineas.at(index).get('FechaInicio').value;
        let fechaFinLinea = this.groupLineas.at(index).get('FechaFin').value;
        fechaInicioLinea = this.datePipe.transform(fechaInicioLinea, 'yyyy-MM-dd');
        fechaFinLinea = this.datePipe.transform(fechaFinLinea, 'yyyy-MM-dd');
        this.formFondo = this.formBuilder.group({
          Tipo: this.groupLineas.at(index).get('Tipo').value,
          idFondo: this.fondo.idFondo,
          Usuario: this.userActive.Usuario,
          FechaInicio: fechaInicioLinea,
          FechaFin: fechaFinLinea,
          FrecuenciaPago: this.groupLineas.at(index).get('FrecuenciaPago').value,
          TasaInteres: this.groupLineas.at(index).get('TasaInteres').value,
          TasaPenalizacion: this.groupLineas.at(index).get('TasaPenalizacion').value,
          Estado: estado
        });

        if (estado == 'A') {
          textSwal = '¡La linea de fondo ha sido activada!';
        } else {
          textSwal = '¡La linea de fondo ha sido deshabilitada!';
        }

        this.riesgoService.actualizarLineaYFrecuenciaFondo(this.formFondo.getRawValue(), this.idLineaFondo).subscribe(
          (resFondo: any) => {
            this.showConfirmSwal(textSwal);
          },
          (err: HttpErrorResponse) => {
            Swal.fire({
              title: 'Error',
              html: this.alertService.createTextError(err, 'Hubo un error a la hora de cambiar de estado a la linea de fondo. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );

      }

    });
  }

  /**
  * Función para activar una linea del fondo (cambio de estado a ACTIVO).
  */
  cambiarEstadoSector(index: number, estado: string) {
    let textSwal = '';

    if (estado == 'A') {
      textSwal = 'Confirmar la activación del sector.';
    } else {
      textSwal = 'Confirmar la desactivación del sector.';
    }

    Swal.fire({
      text: textSwal,
      type: 'info',
      showCancelButton: true,
      cancelButtonText: 'No, cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Si, continuar',
      allowOutsideClick: false,
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {

      if (result.value) {

        Swal.fire({
          title: 'Espere',
          text: 'Guardando los cambios...',
          type: 'info',
          allowOutsideClick: false,
          heightAuto: false
        });
        Swal.showLoading();

        this.formFondo = this.formBuilder.group({
          idFondo: this.fondo.idFondo,
          idSector: this.groupSector.at(index).get('idSector').value,
          Estado: estado,
          Porcentaje: this.groupSector.at(index).get('Porcentaje').value,
          Monto_Sector_Fondo: this.groupSector.at(index).get('Monto_Sector_Fondo').value,
          Monto_Sector_Fondo_Disponible: this.groupSector.at(index).get('Monto_Sector_Fondo_Disponible').value,
          Monto_Sector_Fondo_Ejecutado: this.groupSector.at(index).get('Monto_Sector_Fondo_Ejecutado').value,
          Monto_Sector_Fondo_Bloqueado: this.groupSector.at(index).get('Monto_Sector_Fondo_Bloqueado').value,
          Usuario: this.userActive.Usuario
        });

        if (estado == 'A') {
          textSwal = '¡El sector del fondo ha sido activado!';
        } else {
          textSwal = '¡El sector del fondo ha sido deshabilitado!';
        }

        this.riesgoService.actualizarSectorFondo(this.formFondo.getRawValue(), this.fondo.idFondo).subscribe(
          (resFondo: any) => {
            this.showConfirmSwal(textSwal);
          },
          (err: HttpErrorResponse) => {
            Swal.fire({
              title: 'Error',
              html: this.alertService.createTextError(err, 'Hubo un error a la hora de cambiar de estado al sector del fondo. <br/>'),
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            });
          }
        );

      }

    });
  }

  showConfirmSwal(textSwal: string) {
    Swal.fire({
      title: 'Éxito',
      text: textSwal,
      type: 'success',
      allowOutsideClick: false,
      heightAuto: false
    });

    this.loginService.clickGuard = true;
    this.router.navigate(['/fondo/concentracion/fondos/listado']);
  }


  validarMotivo(){
    this.motivo = true;
    this.verMotivo = false;
  }
}